(function (Drupal, drupalSettings, once) {
  'use strict';

  function resolvePrefillTid() {
    // 1) Prefer drupalSettings from node pages.
    const settingsTid = drupalSettings?.hcCategoryPrefill?.prefillTid;
    if (settingsTid) return String(settingsTid);

    // 2) Try body class like "page-taxonomy-term-903".
    const body = document.body;
    if (body) {
      const classMatch = body.className.match(/(?:^|\s)page-taxonomy-term-(\d+)(?=\s|$)/);
      if (classMatch) return classMatch[1];
    }

    // 3) Fallback to URL pattern like /taxonomy/term/903.
    const pathMatch = window.location.pathname.match(/\/taxonomy\/term\/(\d+)(?:\/|$)/);
    if (pathMatch) return pathMatch[1];

    return null;
  }

  Drupal.behaviors.hcCategoryPrefill = {
    attach(context) {
      const prefillTid = resolvePrefillTid();
      if (!prefillTid) return;

      // Run once per select instance—even if injected later via AJAX.
      once('hcCategoryPrefill', 'select.hc-search-categories', context).forEach((select) => {
        // Accept string/number equality.
        const matching = Array.from(select.options).find((opt) => opt.value == prefillTid);
        if (matching) {
          select.value = matching.value;
          // Fire change for dependent logic/listeners.
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    },
  };
})(Drupal, drupalSettings, once);
